import {LoaderWithContext} from 'utilities/loaders/types';
import MachineTranslationSettingsQuery from 'features/Home/components/TranslationsSyncCard/graphql/MachineTranslationSettingsQuery.graphql';

import {shopLocalesAndMarketsLoader} from './ShopLocalesAndMarkets/loader';
import {shopLoader} from './Shop/loader';

export const loader = (async (args, ctx) => {
  const [{shopLocalesAndMarkets}, {shop}] = await Promise.all([
    shopLocalesAndMarketsLoader(args, ctx),
    shopLoader(ctx),
    // Although we're not consuming data from this query in the loader directly,
    // we're still priming the cache so it's available when the ui renders
    ctx.query({
      query: MachineTranslationSettingsQuery,
    }),
  ]);

  return {shopLocalesAndMarkets, shop};
}) satisfies LoaderWithContext;

export type LoaderType = typeof loader;
